<template>
  <van-popup
    v-model="onShow"
    position="bottom"
    class="pay-popup"
    @closed="onClick"
  >
    <van-row align="center" class="pay-header">
      <van-search
        v-model="searchText"
        @input="onSearch"
        @clear="onReset"
        shape="round"
        :placeholder="$t.meta.search"
      />
    </van-row>

    <div class="pay-content" v-if="items">
      <van-checkbox-group v-model="result">
        <van-cell-group>
          <van-cell
            v-for="(item, index) in items"
            clickable
            :key="index"
            :title="item.text"
            @click="toggle(index, item.disabled)"
          >
            <template #right-icon>
              <van-checkbox
                :name="item.value"
                :disabled="item.disabled"
                ref="checkboxes"
              />
            </template>
          </van-cell>
        </van-cell-group>
      </van-checkbox-group>
    </div>
  </van-popup>
</template>

<script>
import Vue from "vue";
import {
  Popup,
  Row,
  CellGroup,
  Cell,
  Search,
  CheckboxGroup,
  Checkbox,
} from "vant";

Vue.use(Popup)
  .use(Row)
  .use(CellGroup)
  .use(Cell)
  .use(Search)
  .use(CheckboxGroup)
  .use(Checkbox);

export default {
  name: "CheckList",
  props: ["options", "value", "event"],
  data() {
    return {
      searchText: "",
      items: [],
      onShow: false,
      result: [],
    };
  },
  watch: {
    options() {
      this.items = this.options;
    },
  },
  mounted() {
    this.$bus.$off(this.event).$on(this.event, (isShow) => {
      this.onShow = isShow;
      if (this.value) this.result = this.value;
    });
  },
  methods: {
    toggle(index, disabled) {
      if (disabled) {
        return;
      }
      this.$refs.checkboxes[index].toggle();
    },
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value);
    },
    onSearch() {
      var items = [];
      for (const item of this.items) {
        var text = item.text;
        if (text.includes(this.searchText)) {
          items.push(item);
        }
      }
      if (items && items.length > 0) {
        if (this.searchText) {
          this.items = items;
        } else {
          this.items = this.options;
        }
      }
    },
    onReset() {
      this.items = this.options;
    },
    onClick() {
      var data = [];
      for (var id of this.result) {
        var item = this.items.find((p) => p.value == id);
        if (item) {
          data.push(item);
        }
      }
      this.$emit("onSelect", data);
      this.onShow = false;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/publicStyle.scss";
.pay-popup {
  height: 70%;
  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;
  .pay-header {
    width: auto;
    padding: 2%;
    .pay-title {
      width: 100%;
      text-align: center;
      font-weight: bold;
    }
    .pay-subtitle {
      width: 100%;
      text-align: center;
      font-weight: bold;
      font-size: 2rem;
      margin-top: 0.5rem;
      .boxUnit {
        font-size: 1.5rem;
        margin-left: 4px;
        margin-right: 4px;
      }
    }
  }
  .pay-content {
    .nationImg {
      width: 30px;
      height: auto;
    }
  }
}
</style>